// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ir-0";
export var fileCarousel = "_ir-2";
export var removeFileButton = "_ir-1";